/* unplugin-vue-components disabled */import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, "订单金额", -1);
import dayjs from 'dayjs';
import UTable from '@ultra/share/components/UTable/index.vue';
import { UseTable } from '@ultra/share/components/UTable/useTable';
import { apiGSIncomeOrderList } from '@/api/gsManage';
export default /*#__PURE__*/_defineComponent({
  props: {
    gameId: null,
    params: null,
    currency: null,
    filterOrder: null
  },
  setup(__props, {
    expose
  }) {
    const props = __props;
    const columns = [{
      label: '角色ID',
      prop: 'roleId',
      width: 100
    }, {
      label: '角色昵称',
      prop: 'roleName'
    }, {
      label: '订单商品',
      prop: 'goodsName'
    }, {
      label: '订单金额',
      prop: 'currencyAmount',
      header: 'amount_header',
      align: 'right'
    }, {
      label: '下单时间',
      prop: 'create_time',
      slot: 'create_time'
    }];
    const getTableData = async () => {
      var _props$params, _props$params2, _props$params3;
      tableLoading.value = true;
      const res = await apiGSIncomeOrderList({
        current_page: current.value,
        page_size: pageSize.value,
        game_id: props.gameId,
        cid: ((_props$params = props.params) === null || _props$params === void 0 ? void 0 : _props$params.cid) || 0,
        role_id: ((_props$params2 = props.params) === null || _props$params2 === void 0 ? void 0 : _props$params2.role_id) || '',
        server_id: ((_props$params3 = props.params) === null || _props$params3 === void 0 ? void 0 : _props$params3.server_id) || 0,
        currency: props.currency,
        is_over_view: props.params.role_id ? undefined : 1,
        date: props.filterOrder.date && props.filterOrder.date.length ? `${dayjs(props.filterOrder.date[0]).format('YYYY-MM-DD')} - ${dayjs(props.filterOrder.date[1]).format('YYYY-MM-DD')}` : undefined
      });
      tableLoading.value = false;
      if (res.code === 0) {
        tableData.value = res.data;
        total.value = res.meta.pagination.total;
      }
    };
    const {
      tableData,
      tableLoading,
      current,
      pageSize,
      total,
      handleCurrentChange,
      handleSizeChange
    } = UseTable(getTableData);
    watch(() => props.currency, val => {
      if (val) getTableData();
    }, {
      immediate: true
    });
    watch(() => props.filterOrder, val => {
      if (val) getTableData();
    });
    expose({
      getTableData
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(UTable, {
        options: columns,
        "row-key": "id",
        data: _unref(tableData),
        loading: _unref(tableLoading),
        pagination: "",
        total: _unref(total),
        "current-page": _unref(current),
        "page-size": _unref(pageSize),
        onSizeChange: _unref(handleSizeChange),
        onCurrentChange: _unref(handleCurrentChange)
      }, {
        amount_header: _withCtx(() => [_hoisted_1, _createTextVNode("(" + _toDisplayString(__props.currency) + ") ", 1)]),
        create_time: _withCtx(({
          scope
        }) => [_createTextVNode(_toDisplayString(_ctx.$filters.formatDate(scope.row.create_time)), 1)]),
        _: 1
      }, 8, ["data", "loading", "total", "current-page", "page-size", "onSizeChange", "onCurrentChange"]);
    };
  }
});